// The report a migration leaves behind.
//
// An import of five thousand loans cannot be read off a progress bar. What the
// shop needs afterwards is a file: one line per row, what happened to it, and —
// for anything that did not land — the sentence that says why, in the words the
// operator can act on. That file is also how a half-finished import is finished:
// fix the failed rows, re-upload, and the ones that already exist are skipped.
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const OUTCOME_WORDS = {
  created: "Imported",
  ready: "Ready (nothing created — this was a check)",
  skipped: "Already in the app — left untouched",
  failed: "Not imported",
};

export const downloadOutcomeReport = (results, spec, { dryRun } = {}) => {
  // A master sheet has no vouchers: that column carries the record's name, and
  // the ledger column is dead weight. Heading it "Voucher No" would have an
  // operator hunting their old books for a number that was never there.
  const isMaster = spec.kind === "master";
  const rows = [
    isMaster
      ? ["Excel Row", "Account", "What happened", "Details", "Warnings"]
      : [
          "Excel Row",
          "Voucher No",
          "What happened",
          "Details",
          "Warnings",
          "Ledger Voucher",
        ],
    ...results.map((r) => {
      const line = [
        r.row_no ?? "",
        r.voucher_no ?? "",
        OUTCOME_WORDS[r.outcome] || r.outcome,
        r.message || "",
        (r.warnings || []).join(" | "),
      ];
      return isMaster ? line : [...line, r.ledger_voucher_no || ""];
    }),
  ];

  const ws = XLSX.utils.aoa_to_sheet(rows);
  ws["!cols"] = [
    { wch: 10 },
    { wch: isMaster ? 28 : 18 },
    { wch: 34 },
    { wch: 78 },
    { wch: 60 },
    ...(isMaster ? [] : [{ wch: 16 }]),
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(
    wb,
    ws,
    dryRun ? "Check Result" : "Import Result"
  );

  const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const name = spec.fileName.replace(
    /_Template\.xlsx$/,
    dryRun ? "_Check_Result.xlsx" : "_Import_Result.xlsx"
  );
  saveAs(new Blob([buffer], { type: "application/octet-stream" }), name);
};
